import { aclSchema, baseEntitySchema, entityTypeNames } from '@tunasong/schemas'
import { z } from 'zod'
import { navigationEntityWithTypeSchema } from '../element/index.js'

export const searchSummarySchema = baseEntitySchema.extend({
  id: z.string(),
  type: z.enum(entityTypeNames),
  freetext: z.string(),
  parentChain: z.array(navigationEntityWithTypeSchema),
  embedding: z.array(z.number()).optional(),
  /** * @note we don't merge with persistedSchema due to type instantiation depth issues */
  userId: z.string(),
  /** Last editor's userId — drives the Dashboard Phase 2 "Continue working" split.
   * Legacy docs indexed before this field landed will be missing it; the dashboard
   * treats absence as "not me" and routes them to Recently updated. New writes
   * populate the field. */
  lastEditedBy: z.string().describe("Last editor's userId — used by dashboard split").optional(),
  acls: z.array(aclSchema).optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
})

export type SearchSummary = z.infer<typeof searchSummarySchema>

export function isSearchSummary(node: unknown): node is SearchSummary {
  return searchSummarySchema.safeParse(node).success
}
